import { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';
import useCommonAppStore from '@store/CommonAppStore';
import { useAnyCommonAppEnabled } from '@hooks/useAnyCommonAppEnabled';

export const useConnectCommonAppAccount = () => {
  const location = useLocation();
  const { anyTenantHasCommonApp } = useAnyCommonAppEnabled();

  const { updateApplicant } = useCommonAppStore((store) => store);
  const [searchParams, setSearchParams] = useState<URLSearchParams | null>(null);

  useEffect(() => {
    if (!anyTenantHasCommonApp) return;

    const searchParams = new URLSearchParams(location.search);

    const applicantId = searchParams.get('applicantId');
    const requestId = searchParams.get('requestId');

    setSearchParams(searchParams);

    if (applicantId && requestId) {
      updateApplicant({ applicantId, requestId });
    }
  }, [location]);

  return searchParams;
};
